<template>
  <div>
    <nav>
      <ul class="side-nav-bar">
        <profile></profile>
        <side-navigation-items
          @hideMobileNavBar="hideMobileNavBar"
          @showLogoutMenu="showLogoutMenu"
        ></side-navigation-items>
      </ul>
    </nav>
  </div>
</template>

<script>
import Profile from "./Profile";
import SideNavigationItems from "./SideNavigationItems";

export default {
  components: {
    Profile,
    SideNavigationItems
  },
  methods: {
    hideMobileNavBar() {
      this.$emit("hideMobileNavBar");
    },
    showLogoutMenu() {
      this.$emit("showLogoutMenu");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.side-nav-bar {
  margin: 0;
  padding: 0;
  list-style: none;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/other-web/supplier/components/SideNavigationBar.vue